import { Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  InfoWrapper: styled(Flex, {
    width: '100%',
    gap: '$4',

    '@tablet': {
      gap: '$10',
      flexWrap: 'nowrap',
    },
  }),

  MessageInfoWrapper: styled(Flex, {
    width: '100%',
    margin: '$4 0',
  }),

  Tag: styled(Flex, {
    background: '$backgroundSecondary',
    borderRadius: '$small',
    color: '$dark-dark',
    padding: '$2',

    '& svg': {
      marginRight: '$2',
    },

    '@tablet': {
      alignItems: 'center',
    },
  }),

  Wrapper: styled(Flex, {
    flexWrap: 'wrap',

    '@tablet': {
      flexWrap: 'nowrap',
    },
  }),
};

export default styles;
